import { useMapContext, ViewType } from './Map.tsx';
import cn from '../utils/cn.ts';
import PanelStoryNav from './PanelStoryNav.tsx';
import PanelStoryContent from './PanelStoryContent.tsx';
import { forwardRef } from 'react';

export default function PanelStory() {
  const { view } = useMapContext();

  const ref = forwardRef<HTMLElement>;

  return (
    <div
      className={cn(
        'absolute',
        'w-[40vw]',
        'left-[30px]',
        'top-[30px]',
        'bottom-[30px]',
        'shadow-lg',
        'rounded-[12px]',
        'overflow-hidden',
        'z-1000',
        'text-sm',
        'bg-gray-100',
        'transition-[width]',
        'transition-[height]',
        'py-[12px]',
        'px-[40px]',
        'transition-all',
        !view || view.type !== ViewType.Story ? 'translate-x-[-100vw]' : null,
        'flex',
        'flex-col'
      )}
      style={{
        maxWidth: 'calc( min( 600px, 100vw - ( 3 * 30px ) - 270px ) )',
        minWidth: 'calc( min( 480px, 100vw - ( 3 * 30px ) - 270px ) )',
        maxHeight: 'calc( 100vh - ( 2 * 30px ) )',
      }}
    >
      <PanelStoryNav className={cn('flex-[0_0_auto]')} />
      {view && view.type === ViewType.Story && (
        <PanelStoryContent className={cn('flex-1')} key={view.markerIndex} />
      )}
      <PanelStoryNav bottom={true} className={cn('flex-0')} />
    </div>
  );
}
